<template>
  <span>
    <template v-if="showPdas">
      <component
        :is="componentName"
      />
    </template>
    <template v-else>
      <add />
    </template>
  </span>
</template>
<script>
import Add from './Add.vue';
import AddPdas from './Add_pdas.vue';
import AddV3 from './Version3/AddV3.vue';
import AddV4 from './Version7/AddV4.vue';

export default {
  name: 'DashbhoardHome',
  components: {
    Add,
    AddPdas,
    AddV3,
    AddV4,
  },
  data() {
    return {
      showPdas: this.$cgiSettings.showPdas,
      componentName: this.$cgiSettings.addForm.componentName ? this.$cgiSettings.addForm.componentName : 'AddPdas',
    };
  },
};
</script>
